const locale = {
	BACKTOLOGIN: 'Go back to login',
	RESETMYPASSWORD: 'Reset my password',
	SENDRESETLINK: 'Send reset link',
	FORGOTHEADERMESSAGE: 'Forgot your password?',
	FORGOTHEADERSUBMESSAGE: 'No problem, just reset your password here.',
	RESETHEADERMESSAGE: 'Password reset',
	RESETHEADERSUBMESSAGE: 'You are almost done.',
	CONTINUE: 'Continue',
	COMPANYCODE: 'Companycode',
	COMPANY: 'Company',
	USERNAME: 'Username',
	NEWPASSWORD: 'New password',
	REPEATNEWPASSWORD: 'Repeat new password',
	COMPANYREQUIRED: "Please enter your companyshortname",
	USERNAMEREQUIRED: "Please enter your username",
	PASSWORDREQUIRED: "Please enter a new password",
	PASSWORDSMUSTMATCH: "Passwords do not match",
	INVALIDINPUT: "Your input contains invalid characters",
	SHORTINPUT: "Your input is too short",
	NOCOMPANYFOUND: "No company with this code could be found",
	RESETERROR: 'An unknown error occured!',
	RESETWASSUCCESSFUL: 'The password reset was carried out successfully.',
	FORGOTSUCCESSFUL: 'Check your inbox!',
	FORGOTSUCCESSFULSUB: 'We have sent you an email to reset your password. Please click there on the link to complete the process!',
	BACKTOMAIN: "Back to the main page",
	CHANGEHEADERMESSAGE: 'Change password',
	CHANGEHEADERSUBMESSAGE: 'You are almost done.',
	CHANGEMYPASSWORD: "Change my password now",
	OLDPASSWORD: "Current password",
	OLDPASSWORDREQUIRED: "Please enter your current password",
	CHANGEWASSUCCESSFUL: 'The password change was carried out successfully.',
	CHIPINFOHEADERMESSAGE: "NFC chip info",
	WAITINGFORTAG: "Waiting for a chip to scan...",
	STARTNEWSCAN: "Start new scan",
	NFCNOTAVAILABLE: "NFC is not available",
	NFCNOTACTIVATED: "NFC is not activated",
	NFCNOTSUPPORTED: "NFC is not supported on this device",
	NONFCCHIPFOUND: "No NFC chip found",
	NFCCHIPNOTFORMATTED: "NFC chip not formatted",
	NFCCHIPNOTSUPPORTED: "NFC chip not supproted",
	NFCHIPDETECTED: "NFC chip detected, please wait...",
	NFCCHIPISVALID: "NFC Chip ist gültig",
	NFCCHIPUPDATENOTSUPPORTED: "NFC chip udpate not supported on this device",
	NFCHIPRESETSUCCESSFULL: "NFC chip reset successfull",
	NFCHIPUPDATESUCCESSFULL: "NFC chip update successfull",
	NFCDIFFERENTCHIPDETECTED: "Different NFC chip deteceted, operation canceled",
	NFCERROR: "NFC error, operation canceled",
	WAITINGONCHIPFORFORMAT: "Waiting for NFC chip {{chipid}} to format",
	WAITINGONCHIPFORUPDATE: "Waiting for NFC chip {{chipid}} to update",
	FORMATCHIP: "Format",
	UPDATECHIP: "Rewrite chip",
	NFCCHIPCOMPANYDATA: "Chip-Companydata",
	NFCCHIPUSERDATA: "Chip-Userdata",
	NFCCHIPOTHERDATASAVED: "NFC Chip has also not recognized data saved!",
	REGISTEREDTO: "Registered to",
	CHIPNAME: "Chipname",
	DSGVO: "Privacy Policy",
	AGB: "Terms & Conditions",
	COPYRIGHT: "Copyright © Alpsware GmbH",
};

export default locale;
